import { Component, OnInit } from '@angular/core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { SearchService } from '../services/search.service';
import { AuthService } from '../services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {

  faSearch = faSearch;
  searchQuery: string;
  searchError: boolean;
  searchErrorMessage: string = null;
  searchCount: number;
  resultsFromDxSearch;
  foundset;
  foundsetDx9;
  dxPrefix;
  dxYear: string = '';

  search$: Subscription;
  searchYear$: Subscription;


  constructor(private searchService: SearchService, public authService: AuthService, private route: ActivatedRoute ) { }

  ngOnInit() {
    // console.log(this.authService.isLoggedIn());
    if (this.authService.isLoggedIn() === false) {
      this.authService.logout();
    }

    this.route.queryParams.subscribe(prefix => {
      // console.log(prefix);
      this.dxPrefix = prefix;

      // at this point we have the prefix...if it exists.  Let's test to see if it exists
      const dxPrefixAsString: string = JSON.stringify(this.dxPrefix);
      if(dxPrefixAsString !== '{}') {
        if(this.dxPrefix.prefix.length === 3) {
          // console.log(dxPrefix);
          this.search(this.dxPrefix.prefix);
        }
      }

    });

    this.searchYear();
  }

  search(searchQuery: string) {
    // reset searchError in order to hide error message if it existed
    this.searchError = false;
    this.searchCount = 0;
    this.search$ = this.searchService.dxSearch(searchQuery)
    .subscribe(foundset => {
      this.resultsFromDxSearch = foundset;
      this.foundset = this.resultsFromDxSearch.response.data;
      // console.log(this.foundset);
      this.searchCount = this.foundset.length;
      // console.log(this.searchCount);
      this.searchError = false;
      // console.log(this.foundset);
    },
    (notfound) => {
      this.resultsFromDxSearch = notfound;
      // console.log(this.resultsFromDxSearch);
      this.searchError = true;
      if (this.resultsFromDxSearch.error.messages[0].code === '401') {
        this.searchErrorMessage = 'Search not found.  Please try again.';
      } else if ( this.resultsFromDxSearch.error.messages[0].code === '952' ) {
        this.searchErrorMessage = 'Timed out. Please login again.';
        setTimeout ( () => {
          this.authService.logout();
         }, 2000);
      } else { this.searchErrorMessage = 'Unknown search error.  Did you lose your internet connection?'; }
    });
  }

  searchYear() {
    this.searchYear$ = this.searchService.dxYear()
    .subscribe(foundset => {
      // console.log(foundset);
      const foundsetAsString: any = foundset;
      this.dxYear = foundsetAsString.response.data[0].fieldData.YEAR as string;
      // console.log(this.dxYear);
    });
  }






  ngOnDestroy(): void {
    if (this.search$) {
      this.search$.unsubscribe();
    }
    if (this.searchYear$) {
      this.searchYear$.unsubscribe();
    }
  }

}
